import Vue from 'vue'

export default {
  getWebinars ({ commit }) {
    return Vue.axios.get(`/events/webinars`)
    .then(({ data }) => commit('ADD_WEBINARS', data))
  },
  addWebinar ({ commit }, data) {
    commit('ADD_NEW_WEBINAR', data)
  },
  saveWebinar ({ commit }, webinar) {
    return Vue.axios.put(`/events/webinars`, { webinar })
  },
  updateWebinar ({ commit }, webinar) {
    commit('UPDATE_WEBINAR', webinar)
  },
  deleteWebinar ({ commit }, id) {
    return Vue.axios.delete(`/events/webinars/${id}`)
    .then(() => commit('DELETE_WEBINAR', id))
  },
  getSpeakers ({ commit }) {
    return Vue.axios.get(`/events/webinars/speakers`)
    .then(({ data }) => commit('ADD_SPEAKERS', data))
  },
  addWebinarSpeaker ({ commit }, data) {
    commit('ADD_WEBINAR_SPEAKER', data)
  },
  deleteWebinarSpeaker ({ commit }, id) {
    commit('DELETE_WEBINAR_SPEAKER', id)
    return Vue.axios.delete(`/events/webinars/speakers/${id}`)
  },
  saveWebinarSpeaker ({ commit, dispatch }, speaker) {
    let newPhoto
    if (speaker.photo && typeof speaker.photo === 'object') {
      newPhoto = speaker.photo.data
      delete speaker.photo
    }
    return Vue.axios.put(`/events/webinars/speakers/${speaker.id}`, { speaker })
    .then(() => {
      newPhoto && dispatch('loadWebinarSpeakerPhoto', { formData: newPhoto, id: speaker.id })
    })
  },
  updateWebinarSpeaker ({ commit }, speaker) {
    commit('UPDATE_WEBINAR_SPEAKER', speaker)
  },
  loadWebinarSpeakerPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/webinars/speakers/change-photo/${id}`, formData)
  },
  addWebinarSpeakerPhoto ({ commit }, photo) {
    commit('CHANGE_WEBINAR_SPEAKER_PHOTO', photo)
  },
  deleteWebinarSpeakerPhoto ({ commit }, id) {
    setTimeout(() => { commit('DELETE_WEBINAR_SPEAKER_PHOTO', id) }, 100)
  },
  getWebinarReviews ({ commit }) {
    return Vue.axios.get('/events/webinars/reviews')
    .then(({ data }) => commit('ADD_WEBINAR_REVIEWS', data))
  },
  deleteWebinarReview ({ commit }, id) {
    return Vue.axios.delete(`/events/webinars/reviews/${id}`)
    .then(() => commit('DELETE_WEBINAR_REVIEW', id))
  },
  publishWebinarReview ({ commit }, id) {
    return Vue.axios.put(`/events/webinars/reviews/${id}/publish`)
    .then(() => commit('PUBLISH_WEBINAR_REVIEW', id))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/webinars.js